import React, { useCallback } from 'react';
import { Textbox, TextboxValue } from '@cvent/carina/components/Forms';
import { ValidatorFunc } from '@cvent/carina/components/Forms/FormContext';
import { useTranslate } from 'nucleus-text';

import { validateFormField } from '@components/helpers/FormHelpers';

type PasswordProps = {
  testID: string;
  name?: string;
  label?: string;
  dependencies?: Array<string>;
  validator?: ValidatorFunc<TextboxValue>;
  autoComplete?: string;
};

export const PasswordTextbox = (props: PasswordProps): JSX.Element => {
  const { translate } = useTranslate();
  const validate = useCallback(
    val => validateFormField(val, translate('redirect_required_password_error_message')),
    [translate]
  );
  const {
    testID,
    name = 'password',
    label = translate('password__resx'),
    dependencies,
    validator = validate,
    autoComplete = 'current-password'
  } = props;

  return (
    <Textbox
      name={name}
      label={label}
      testID={`${testID}_${name}`}
      validate={validator}
      type={'password'}
      dependencies={dependencies}
      autoComplete={autoComplete}
    />
  );
};
